export const twelveHourUserSetting = 'hh:mm az';

export const twelveHourZoneSpacedUserSetting = 'hh:mm a z';

export const twelveHourUserSettingsNoTimeZoneUnpadded = 'h:mm a';

export const twelveHourUserSettingsNoTimeZone = 'hh:mm a';

export const twelveHourUserSettingForBrandedEmail = 'h:mma';

export const twelveHourSettingForTimePicker = 'h:mmA';

export const twentyFourHourTimeUnpadded = 'H:mm';

export const twentyFourHourTimePadded = 'HH:mm';

export const twelveHourPrefix = 'h';
